import { render, staticRenderFns } from "./LicensesSVG.vue?vue&type=template&id=5d9460f7"
import script from "./LicensesSVG.vue?vue&type=script&lang=js"
export * from "./LicensesSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports